export const scrollToAnchor = (anchorId: string, offset: number = 0) => {
  let top = 0;
  if (anchorId !== "top") {
    const element = document.getElementById(anchorId);
    if (!element) return;
    top = element.getBoundingClientRect().top + window.scrollY - offset;
  }
  window.scrollTo({
    top,
    behavior: "smooth",
  });
};
